module.exports = __webpack_public_path__ + "img/pic3.90a436a.webp";